module.exports = __webpack_public_path__ + "static/media/custom-ex-11.860431eb.jpg";